import { OWDataType } from "@multiweb/types/contracts";
import { IItemRightsCollection } from "../../../../Global/Base/Rights/RightTypes";
import { Control } from "./Control";

/**
 * Parametry konstruktoru tridy {@link ContainerControl}.
 */
export type ContainerControlParams = {
    elementCreator: new() => HTMLElement;
    copyAttrs?: Map<string, string>;
    onSetDataType?: (element: HTMLElement, dataType: OWDataType) => void;
    parentElement: HTMLElement;
    originalRightsDefinition: IItemRightsCollection;
    attrSourceElement?: HTMLElement;
};

export class ContainerControl extends Control {
    //#region Fields
    public innerElement: HTMLElement;

    protected _value: string;

    private readonly _attrSourceElement: HTMLElement;
    private readonly _elementCreator: new() => HTMLElement;
    private readonly _copyAttrs: Map<string, string>;
    private _dataType: OWDataType;
    //#endregion Fields

    //#region Constructors
    constructor({ elementCreator, copyAttrs, onSetDataType, parentElement, originalRightsDefinition, attrSourceElement = null }: ContainerControlParams) {
        super({ element: parentElement, originalRightsDefinition });

        this._onSetDataType = onSetDataType;
        this._elementCreator = elementCreator;
        this._copyAttrs = copyAttrs ?? new Map();
        // pro kopírování atributů se použije attrSourceElement pokud je specifikovaný, jinak se vezme rodičovský element - často mohou být různé a takto je možné je rozlišit
        this._attrSourceElement = attrSourceElement != null ? attrSourceElement : parentElement;

        this._createElement();
    }
    //#endregion Constructors

    //#region Properties
    //#endregion Properties

    //#region Methods

    /** Vytvori samotny element */
    protected _createElement(): void {
        const input = new this._elementCreator();

        for (const attr of Array.from(this._attrSourceElement.attributes)) {
            if (this._copyAttrs.has(attr.name)) {
                input.setAttribute(this._copyAttrs.get(attr.name), attr.value);
            }
        }

        this.innerElement = input;
        this.element.appendChild(this.innerElement);
    }

    // slouzi pro nastaveni property na komponente pri zmene DataType
    private _onSetDataType: (element: HTMLElement, dataType: OWDataType) => void;

    public get dataType(): OWDataType {
        return this._dataType;
    }

    public set dataType(value: OWDataType) {
        this._dataType = value;
        if (this.innerElement && this._onSetDataType) {
            this._onSetDataType(this.innerElement, value);
        }
    }

    //#endregion Methods
}
